import React, { FC } from 'react';
import styled from 'styled-components';
import { SoftDeclineError } from '~/types/SoftDeclineError';
import { getErrorMessages } from './utils';

interface Props {
  errors: SoftDeclineError[];
}

const DeclineReasonsList: FC<Props> = (props) => {
  const { errors } = props;
  const errorMessages = getErrorMessages(errors);
  const isStringsArray = errors.every((i: any) => typeof i === 'string');
  return (
    <Ul>
      {isStringsArray
        ? errors?.map((message: any) => {
            return <li key={message}>{message}</li>;
          })
        : errorMessages.map((item) => {
            return (
              <li key={item.message}>
                Rejected by {item.reviewer}: {item.message} 
              </li>
            );
          })}
    </Ul>
  );
};

const Ul = styled.ul`
  list-style-type: disc !important;
`;

export default DeclineReasonsList;
